import * as managementGiftForm from '../services/managementGiftForm';
import { fmtThousand } from '@/utils/comUtil';
import dayjs from 'dayjs';

export default {
  namespace: 'managementGiftForm',
  state: {},
  effects: {
    *editManagementGiftForm(
      { payload: { values }, callback },
      { call, select },
    ) {
      console.log('values', values);

      const memberLevels = yield select(
        (state) => state.luckDrawViewSetting.memberLevels,
      );
      const minPointInit = values.minPoint
        ? values.minPoint.replace(/,/g, '')
        : values.minPoint;

      const personalGiftClaimLimitInit = values.personalGiftClaimLimit
        ? values.personalGiftClaimLimit.replace(/,/g, '')
        : values.personalGiftClaimLimit;
      const stock = values.stock
        ? values.stock.replace(/,/g, '')
        : values.stock;
      const coupon =
        (values.receiveMethod === 'TAKE_THEIR' &&
          values.type === 'REAL_PRIZE') ||
        values.type === 'COUPON'
          ? {
              beginTime: values.couponInfo.beginTime,
              couponId: values.couponInfo.couponId,
              couponName: values.couponInfo.couponName,
              couponType: 4,
              endTime: values.couponInfo.endTime,
            }
          : null;
      const vipLimit = values.rule?.includes('888') ? 1 : 0;
      const isNewMember = values.rule?.includes('1') ? 1 : 0;
      const isOldMember = values.rule?.includes('2') ? 1 : 0;
      const minPoint = values.rule?.includes('3') ? minPointInit : null;
      const personalGiftClaimLimit = values.rule?.includes('5')
        ? personalGiftClaimLimitInit
        : null;
      const receiveMethod =
        values.type === 'REAL_PRIZE' ? values.receiveMethod : null;
      const levels =
        values.rule?.includes('4') && values.levels
          ? memberLevels
              .filter((i) => i.code >= Number(values.levels))
              .map((i) => String(i.code))
          : null;

      const exchangeMethod = values.exchangeMethod;
      const exchangePoint = values.exchangePoint
        ? values.exchangePoint.replace(/,/g, '')
        : 0;
      const exchangeCost = values.exchangeCost
        ? values.exchangeCost.replace(/,/g, '')
        : 0;
      const params = {
        beginDateTime: values.date
          ? `${dayjs(values.date.startDate).format('YYYY-MM-DD')} 00:00:00`
          : null,
        cost: exchangeMethod === 'CASH' ? exchangeCost : 0,
        points: exchangeMethod === 'POINTS' ? exchangePoint : 0,
        exchangeMethod,
        coupon,
        coverImage: values.coverImage[0],
        description: values.description,
        endDateTime: values.date
          ? `${dayjs(values.date.endDate).format('YYYY-MM-DD')} 23:59:59`
          : null,
        images: values.images,
        vipLimit,
        isNewMember,
        isOldMember,
        levels,
        minPoint,
        personalGiftClaimLimit,
        receiveMethod,
        stock,
        title: values.title,
        type: values.type,
        id: values.id,
        isRefundable: values.isRefundable,
        postageAmount:
          values.postageStatus === '1' ? values.postageAmount : null,
        postageStatus: values.postageStatus,
      };
      const res = values.id
        ? yield call(managementGiftForm.updateGift, params, callback)
        : yield call(
            managementGiftForm.editManagementGiftForm,
            params,
            callback,
          );
      callback(res);
    },
    *getQueryGiftDetail({ payload: { values } }, { call, put }) {
      const res = yield call(managementGiftForm.getQueryGiftDetail, values);
      const cost = fmtThousand(res.data.cost);
      const minPoint = res.data.minPoint ? fmtThousand(res.data.minPoint) : 0;
      const surplusStock = res.data.surplusStock
        ? fmtThousand(res.data.surplusStock)
        : 0;
      const personalGiftClaimLimit = res.data.personalGiftClaimLimit
        ? fmtThousand(res.data.personalGiftClaimLimit)
        : 0;
      const exchangeMethod = res.data.exchangeMethod;
      const exchangePointInit = res.data.points;
      const exchangeCostInit = res.data.cost;
      const exchangePoint = exchangePointInit
        ? fmtThousand(exchangePointInit)
        : '';
      const exchangeCost = exchangeCostInit
        ? fmtThousand(exchangeCostInit)
        : '';
      const stock = fmtThousand(res.data.stock);
      const rule = [];
      console.log('000');
      if (res.data.vipLimit) {
        rule.push('888');
      }
      if (res.data.isNewMember) {
        rule.push('1');
      }
      if (res.data.isOldMember) {
        rule.push('2');
      }
      if (res.data.minPoint) {
        rule.push('3');
      }
      if (res.data.levels && res.data.levels?.length > 0) {
        rule.push('4');
      }
      if (res.data.personalGiftClaimLimit) {
        rule.push('5');
      }
      const levels = res.data.levels
        ? res.data.levels.map((item) => String(item))[0]
        : null;
      const params = {
        title: res.data.title,
        cost,
        couponInfo: res.data.coupon,
        coverImage: [res.data.coverImage],
        description: res.data.description,
        date: {
          startDate: res.data.beginDateTime,
          endDate: res.data.endDateTime,
        },
        images: res.data.images,
        rule,
        levels,
        minPoint,
        personalGiftClaimLimit,
        exchangeMethod,
        exchangePoint,
        exchangeCost,
        receiveMethod: res.data.receiveMethod,
        stock,
        surplusStock,
        type: res.data.type,
        code: res.data.code,
        postageAmount: res.data.postageAmount
          ? String(res.data.postageAmount)
          : '',
        postageStatus: String(res.data.postageStatus),
        isRefundable: String(res.data.isRefundable),
      };
      yield put({
        type: 'save',
        payload: {
          detailInfo: params,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname.includes('management_gift_form_edit') ||
          props.pathname.includes('management_gift_form_add') ||
          props.pathname.includes('management_gift_form_detail')
        ) {
          dispatch({
            type: 'save',
            payload: {
              detailInfo: null,
            },
          });
        }
      });
    },
  },
};
